

























import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import {mixins} from "vue-class-component"
import UniqueIdMixin from "@/design-system/utilities/UniqueIdMixin"
import JdhHeightTransition from "@/design-system/shared/JdhHeightTransition.vue"

@Component({
    components: {JdhHeightTransition}
})
export default class JdhFieldStructure extends mixins(UniqueIdMixin) {
    @Prop({type: Boolean, default: false}) fieldset!: boolean
    @Prop({default: null}) width!: number

    @Prop({type: Boolean, default: false}) hasError!: boolean
    @Prop({type: Boolean, default: false}) required!: boolean

    @Prop({default: 'below'}) hintPosition!: 'below'|'above'

    get wrapperStyles() {
        return {
            width: '100%',
            maxWidth: this.width ? `${this.width * 1.5}ch` : '100%',
            minWidth: 'min-content',
        }
    }
}
